var _path, _path2, _path3, _path4;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHardDrives = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 18H6C5.44772 18 5 18.4477 5 19V25C5 25.5523 5.44772 26 6 26H26C26.5523 26 27 25.5523 27 25V19C27 18.4477 26.5523 18 26 18Z",
    stroke: "#75757D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6H6C5.44772 6 5 6.44772 5 7V13C5 13.5523 5.44772 14 6 14H26C26.5523 14 27 13.5523 27 13V7C27 6.44772 26.5523 6 26 6Z",
    stroke: "#75757D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.5C23.3284 11.5 24 10.8284 24 10C24 9.17157 23.3284 8.5 22.5 8.5C21.6716 8.5 21 9.17157 21 10C21 10.8284 21.6716 11.5 22.5 11.5Z",
    fill: "#75757D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 23.5C23.3284 23.5 24 22.8284 24 22C24 21.1716 23.3284 20.5 22.5 20.5C21.6716 20.5 21 21.1716 21 22C21 22.8284 21.6716 23.5 22.5 23.5Z",
    fill: "#75757D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHardDrives, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hard-drives.66d2c155.svg";
export { ForwardRef as ReactComponent };